export const siteTitle = 'お墓・霊園探しならライフドット'
export const siteDescription =
  'Life.(ライフドット)は全国8,700件以上の霊園情報を掲載してお墓・霊園探しをサポート。石材店や葬儀会社で働いた経験のある専門家のアドバイスを元に、お墓の種類・価格、選び方まで詳しく解説しています。【元葬祭・仏壇・墓石販売業者が監修】'
